export default {"src":"/newStatic/_next/static/media/launchpad_icon.1cd19e4b.svg","height":49,"width":48};